import React, { memo } from 'react'

import { Icon, Trash } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, func, number, shape, string } from 'prop-types'

const REMOVE_ICON_SIZE = { width: '16px', height: '16px' }
const removeIcon = <Icon svgComponent={Trash} size={REMOVE_ICON_SIZE} color="dark" notSpaced />

// Reference thumbnails (with remove buttons) and quick-action tags shown above
// the composer input while there are attachments.
function References({ attachments, tags, onRemoveAttachment, onTagClick }) {
  return (
    <div className="image-assistant-panel__composer-refs">
      <div className="image-assistant-panel__composer-thumbs">
        {attachments.map(image => (
          <div key={image.id} className="image-assistant-panel__composer-thumb">
            <img className="image-assistant-panel__composer-thumb-image" src={image.url} alt="" />
            <button
              type="button"
              className="image-assistant-panel__composer-thumb-remove"
              aria-label="Remove image"
              onClick={() => onRemoveAttachment(image.id)}
            >
              {removeIcon}
            </button>
          </div>
        ))}
      </div>
      <div className="image-assistant-panel__tags">
        {tags.map(tag => (
          <button
            key={tag}
            type="button"
            className="image-assistant-panel__tag cgt-caption-semibold"
            onClick={() => onTagClick(tag)}
          >
            {tag}
          </button>
        ))}
      </div>
    </div>
  )
}

References.propTypes = {
  attachments: arrayOf(shape({ id: number.isRequired, url: string.isRequired })).isRequired,
  tags: arrayOf(string).isRequired,
  onRemoveAttachment: func.isRequired,
  onTagClick: func.isRequired,
}

export default memo(References)
